import { Component, ChangeDetectionStrategy, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdditionalInformationRightSectionComponent } from "../additional-information-right-section/additional-information-right-section.component";
import { CalendarViewComponent } from '../../../shared/components/calendar-view/calendar-view.component';
import { AdditionalInformation } from '../../../models/enums/additionalInformation';
import { ActivatedRoute } from '@angular/router';
import { UserSelectors } from '../../../states/user/user-selector';
import { Store } from '@ngxs/store';


@Component({
  selector: 'app-general-tasks',
  standalone: true,
  imports: [CommonModule, AdditionalInformationRightSectionComponent, CalendarViewComponent],
  templateUrl: './general-tasks.component.html',
  styleUrl: './general-tasks.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class GeneralTasksComponent implements OnInit{

  @ViewChild(CalendarViewComponent) calendarView!: CalendarViewComponent;

  infotype=AdditionalInformation;
  userId: string = '';
  mentorId: string = '';

  constructor(private route: ActivatedRoute, private store: Store){}

  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get('id') || '';
    this.getMentor();
  }

  getMentor() {
    this.store.select(UserSelectors.getUser).subscribe({
      next: (response) => {
        this.mentorId = response.id;
      }
    });
  }

  refreshCalendar() {
    if (this.calendarView) {
      this.calendarView.loadAllTasks();
    }
  }
}
